export default __webpack_public_path__ + "static/media/animate-rocket-2.9ce236c7.png";